module.exports = __webpack_public_path__ + "static/img/img_1.5195ef13.jpg";